import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { Extract } from './types';
import { GET_EXTRACTS } from '../constants';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import type { BaseRequestResponse } from '@/_types/services';

type ParamsProps = {
  deliverymanId: string;
  limit?: number;
  page?: number;
  startDate?: string;
  endDate?: string;
};

const getExtracts = (params: ParamsProps) => {
  const { deliverymanId, startDate, endDate, limit, page } = params || {};

  const newPage = page || 1;
  const newLimit = limit || DEFAULT_LIMIT_REQUEST;
  const offset = (newPage - 1) * newLimit;

  return apiClient
    .get<
      BaseRequestResponse<{
        limit: number;
        offset: number;
        results: Extract[];
        total_count: number;
      }>
    >(`/entregadores/${deliverymanId}/bank/extrato`, {
      params: {
        dataInicio: startDate,
        dataFim: endDate,
        limit: newLimit,
        offset,
      },
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetExtracts = Awaited<ReturnType<typeof getExtracts>>;

export const useGetExtracts = (
  params: ParamsProps,
  options: Omit<
    UseQueryOptions<
      GetExtracts,
      unknown,
      GetExtracts,
      (string | ParamsProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_EXTRACTS, params],
    queryFn: () => getExtracts(params),
    ...options,
  });
};
